module.exports = __webpack_public_path__ + "media/images/Tent and Truck-e75fefc9.webp";